<script>

    import Common from "../public/lib/common";
    import Rest from "../public/lib/rest";

    let allClients = [];

    export function setup() {
        Rest.getAllClients().then(function (response) {
            allClients = response.value;
        }).catch(function (present) {
        });
    }

    function editClient(clientVal) {
        Common.eventBus.emit('editClient', null, clientVal, (client) => {
            Rest.saveClient(client).then(function (response) {
                alert("Zapisano");
            }).catch(function (present) {
                present.json().then(body => {
                    alert(body.description);
                });
            });
        });
    }

    function addNewClient() {
        Common.eventBus.emit('newClient', null, (client) => {
            Rest.saveClient(client).then(function (response) {
                alert("Zapisano");
            }).catch(function (present) {
                present.json().then(body => {
                    alert(body.description);
                });
            });
        });
    }
</script>


<div class="row">
    <div class="col-12 mt-4">
        <main class="chart-container menuButtonsContainer">
            <button type="button" class="menuButton btn  btn-info maxWt200"
                    on:click="{addNewClient}">
                <span><i class="fas fa-plus"></i> Nowy klient</span>
            </button>
        </main>
    </div>

    <div class="col-12 mt-4">
        <main class="chart-container">
            <div class="largeFontDiv">Klienci</div>

            <table class="table table-dark noMarginBottom">

                <thead>
                <tr>
                    <th></th>
                    <th>Imię</th>
                    <th>Nazwisko</th>
                    <th>Nr telefonu</th>
                    <th>Pesel</th>
                    <th>Adres e-mail</th>
                    <th>Zgoda na smsy</th>
                    <th>Zgoda na mejle</th>
                </tr>
                </thead>
                <tbody>

                {#each allClients as client, i}
                    <tr>
                        <td>
                            <button type="button" class="menuButton btn btn-sm btn-info maxWt200"
                                    on:click="{editClient(client)}">
                                <span>Edycja</span>
                            </button>
                        </td>
                        <td>{client.name1}</td>
                        <td>{client.name2}</td>
                        <td>{client.phone}</td>
                        <td>{client.pesel}</td>
                        <td>{client.mail}</td>
                        <td>
                            {#if client.smsApprove === true}
                                <b>TAK</b>
                            {:else}
                                <b>NIE</b>
                            {/if}
                        </td>
                        <td>
                            {#if client.mailApprove === true}
                                <b>TAK</b>
                            {:else}
                                <b>NIE</b>
                            {/if}
                        </td>
                    </tr>
                {/each}
                </tbody>
            </table>

        </main>
    </div>
</div>


<style>

</style>
